import { CloseIcon } from "@chakra-ui/icons";
import {
  Button,
  Checkbox,
  Flex,
  FormLabel,
  Grid,
  GridItem,
  IconButton,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Radio,
  RadioGroup,
  Select,
  Stack,
  Text,
  Textarea,
  useBreakpointValue,
} from "@chakra-ui/react";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { LiaMousePointerSolid } from "react-icons/lia";
import { TaskSchema } from "common/schema";
import { getApi, putApi } from "common/services/api";
import ContactModel from "common/components/commonTableModel/ContactModel";
import LeadModel from "common/components/commonTableModel/LeadModel";
import Spinner from "common/components/spinner/Spinner";
import moment from "moment";
import { DepartmentSchema } from "common/schema/department/departmentSchema";
import { toast } from "react-toastify";
import { constant } from "common/constant";
import { API_PATHS } from "common/services/apiPaths";

const EditTask = (props) => {
  const { onClose, isOpen, fetchData, setAction } = props;
  const [isChecked, setIsChecked] = useState(false);
  const userId = JSON.parse(localStorage.getItem("user"))._id;
  const user = JSON.parse(localStorage.getItem("user"));
  const [assignmentToData, setAssignmentToData] = useState([]);
  const [contactModelOpen, setContactModel] = useState(false);
  const [leadModelOpen, setLeadModel] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const initialValues = {
    name: "",
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: DepartmentSchema,
    onSubmit: (values, { resetForm }) => {
      EditData();
    },
  });

  const {
    errors,
    touched,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = formik;
  const EditData = async () => {
    try {
      setIsLoading(true);

      let response = await putApi(
        `${API_PATHS.RECRUITMENT_DEPARTMENTS}${props.id}`,
        values
      );
      if (response.status === 200) {
        formik.resetForm();
        props.viewClose();
        onClose(false);
        // fetchData()
        setAction((pre) => !pre);
      }
    } catch (e) {
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTaskData = async () => {
    if (props.id) {
      try {
        setIsLoading(true);
        let result = await getApi(API_PATHS.RECRUITMENT_PROFILES, props.id);

        setFieldValue("name", result?.data?.name);
      } catch (e) {
        toast.error("Something went wrong");
      } finally {
        setIsLoading(false);
      }
    }
  };

  const getContactDetails = async () => {
    try {
      let result;
      if (values.category === "Contact") {
        result = await getApi(
          user.role === "superAdmin"
            ? "api/contact/"
            : `api/contact/?createBy=${user._id}`
        );
      } else if (values.category === "Lead") {
        result = await getApi(
          user.role === "superAdmin"
            ? "api/lead/"
            : `api/lead/?createBy=${user._id}`
        );
      }
      if (values.category === "Lead") {
        setAssignmentToData(result?.data?.data);
      } else if (values.category === "Contact") {
        setAssignmentToData(result?.data?.data);
      }
    } catch (e) {
      toast.error("Something went wrong");
    }
  };

  useEffect(() => {
    getContactDetails();
  }, [values.category]);

  useEffect(() => {
    fetchTaskData();
    getContactDetails();
  }, [props.id, isOpen]);
  return (
    <Modal isOpen={isOpen} size={"xl"}>
      {!props.from && <ModalOverlay />}
      <ModalContent overflowY={"auto"} height={"250px"}>
        <ModalHeader justifyContent="space-between" display="flex">
          {constant.editJobProfile}
          <IconButton
            size="xs"
            className="closeIcon"
            onClick={() => onClose(false)}
            icon={<CloseIcon />}
          />
        </ModalHeader>
        <ModalBody>
          {/* Contact Model  */}
          <ContactModel
            isOpen={contactModelOpen}
            data={assignmentToData}
            onClose={setContactModel}
            values={values}
            fieldName="assignmentTo"
            setFieldValue={setFieldValue}
          />
          {/* Lead Model  */}
          <LeadModel
            isOpen={leadModelOpen}
            data={assignmentToData}
            onClose={setLeadModel}
            values={values}
            fieldName="assignmentToLead"
            setFieldValue={setFieldValue}
          />
          {isLoading ? (
            <Flex justifyContent={"center"} alignItems={"center"} width="100%">
              <Spinner />
            </Flex>
          ) : (
            <Grid templateColumns="repeat(12, 1fr)" gap={3}>
              <GridItem colSpan={{ base: 12, md: 6 }}>
                <FormLabel
                  display="flex"
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  mb="8px"
                >
                  Name<Text color={"red"}>*</Text>
                </FormLabel>
                <Input
                  fontSize="sm"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.name}
                  name="name"
                  placeholder="Name"
                  fontWeight="500"
                  borderColor={errors?.name && touched?.name ? "red.300" : null}
                />
                <Text mb="10px" color={"red"} fontSize="sm">
                  {" "}
                  {errors.name && touched.name && errors.name}
                </Text>
              </GridItem>
            </Grid>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            sx={{
              marginRight: 4,
              textTransform: "capitalize",
            }}
            variant="outline"
            className="theme-btn2 cancelBtn"
            size="sm"
            onClick={() => onClose(false)}
          >
            {constant.close}
          </Button>

          <Button
            className="theme-btn1"
            variant="brand"
            sx={{ textTransform: "capitalize" }}
            size="sm"
            onClick={handleSubmit}
          >
            {constant.update}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default EditTask;
